export default __webpack_public_path__ + "static/media/bread.3829698f.svg";